<template>
  <div>
    <header class="tl-nav">
      <div class="tl-nav__inner">

        <!-- Logo -->
        <router-link to="/" class="tl-nav__logo">
          <img
            src="../../../../public/frontend/assets/images/header1-logo.svg"
            alt="TradeLinkJA"
            class="tl-nav__logo-img"
          />
        </router-link>

        <!-- Desktop links -->
        <nav class="tl-nav__links">

          <!-- Logged OUT -->
          <template v-if="!loggedIn">
            <router-link to="/post-a-job" class="tl-nav__link">Post a job</router-link>
            <router-link to="/login" class="tl-nav__link">Log in</router-link>
            <router-link to="/register" class="tl-nav__btn">Sign up as a tradesperson</router-link>
          </template>

          <!-- Logged IN -->
          <template v-else>
            <router-link to="/new-leads" class="tl-nav__link">New leads</router-link>
            <router-link to="/my-proposals/contacts" class="tl-nav__link">Contacts</router-link>

            <!-- Registration incomplete badge -->
            <a v-if="!isRegistrationComplete" @click="completeRegistration" class="tl-nav__link tl-nav__link--alert" style="cursor:pointer">
              Complete registration
              <span v-if="registrationSteps" class="tl-nav__badge">{{ registrationSteps }} left</span>
            </a>

            <!-- Account dropdown -->
            <div class="tl-nav__dropdown-wrap" ref="accountWrap">
              <button class="tl-nav__btn tl-nav__btn--account" @click.stop="accountOpen = !accountOpen">
                My Account
                <i class="bi bi-list"></i>
                <span v-if="inboxCount" class="tl-nav__inbox">{{ inboxCount }}</span>
              </button>
              <div class="tl-nav__dropdown" :class="{ 'is-open': accountOpen }" @click="accountOpen = false">
                <router-link to="/profile" class="tl-nav__dropdown-item">
                  <i class="bi bi-person-circle"></i> Profile
                  <span v-if="inboxCount" class="tl-nav__badge">{{ inboxCount }}</span>
                </router-link>
                <router-link to="/ask-a-trade" class="tl-nav__dropdown-item">
                  <i class="bi bi-people"></i> Ask a tradesperson
                </router-link>
                <router-link to="/logout" class="tl-nav__dropdown-item tl-nav__dropdown-item--danger">
                  <i class="bi bi-box-arrow-right"></i> Log Out
                </router-link>
              </div>
            </div>
          </template>
        </nav>

        <!-- Mobile hamburger -->
        <button class="tl-nav__hamburger" aria-label="Open menu" @click="mobileOpen = true">
          <i class="bi bi-list"></i>
        </button>
      </div>

      <!-- Mobile drawer -->
      <div class="tl-nav__mobile" :class="{ 'show-menu': mobileOpen }">
        <div class="tl-nav__mobile-header">
          <router-link to="/">
            <img src="../../../../public/frontend/assets/images/header1-logo.svg" alt="TradeLinkJA" style="height:60px">
          </router-link>
          <button class="tl-nav__mobile-close" aria-label="Close menu" @click="mobileOpen = false">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="tl-nav__mobile-links">
          <template v-if="!loggedIn">
            <router-link to="/post-a-job" class="tl-nav__mobile-link"><i class="bi bi-briefcase tl-nav__mobile-icon"></i>Post a job</router-link>
            <router-link to="/login" class="tl-nav__mobile-link"><i class="bi bi-box-arrow-in-right tl-nav__mobile-icon"></i>Log in</router-link>
            <router-link to="/register" class="tl-nav__mobile-link tl-nav__mobile-link--btn"><i class="bi bi-person-plus"></i> Sign up as a tradesperson</router-link>
          </template>
          <template v-else>
            <a v-if="!isRegistrationComplete" @click="completeRegistration" class="tl-nav__mobile-link" style="cursor:pointer">
              <i class="bi bi-exclamation-circle tl-nav__mobile-icon"></i>Complete registration <span v-if="registrationSteps" class="tl-nav__badge">{{ registrationSteps }} left</span>
            </a>
            <router-link to="/profile" class="tl-nav__mobile-link"><i class="bi bi-person-circle tl-nav__mobile-icon"></i>Profile</router-link>
            <router-link to="/ask-a-trade" class="tl-nav__mobile-link"><i class="bi bi-people tl-nav__mobile-icon"></i>Ask a tradesperson</router-link>
            <router-link to="/logout" class="tl-nav__mobile-link"><i class="bi bi-box-arrow-right tl-nav__mobile-icon"></i>Log Out</router-link>
          </template>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "HomeMenu",
  data() {
    return {
      user: this.$store.getters.GET_USER_INFO || {},
      inboxCount: this.$store.getters.GET_INBOX_COUNT || 0,
      mobileOpen: false,
      accountOpen: false,
    };
  },
  watch: {
    '$store.getters.GET_INBOX_COUNT': {
      handler(count) { this.inboxCount = count || 0 },
      immediate: true,
      deep: true
    },
    // Close the mobile drawer and account dropdown whenever the route changes.
    '$route'() { this.mobileOpen = false; this.accountOpen = false }
  },
  computed: {
    // Steps remaining in the 7-step registration; guard against a missing/
    // non-numeric registration_step so it never renders "NaN left".
    registrationSteps() {
      const step = Number(this.user.registration_step);
      return Number.isFinite(step) ? Math.max(0, 8 - step) : null;
    },
    isRegistrationComplete() { return this.user.registration_status === 'complete' },
    loggedIn() { return this.$store.getters.GET_USER_INFO }
  },
  methods: {
    completeRegistration() {
      const routes = { 1: '/create-account', 2: '/professions', 3: '/travel-to-work', 4: '/business-type', 5: '/business-details', 6: '/verify-identity', 7: '/verify-skills' }
      if (routes[this.user.registration_step]) this.$router.push(routes[this.user.registration_step])
    },
    closeAccountOnOutsideClick(e) {
      if (this.accountOpen && this.$refs.accountWrap && !this.$refs.accountWrap.contains(e.target)) {
        this.accountOpen = false;
      }
    }
  },
  mounted() { document.addEventListener('click', this.closeAccountOnOutsideClick); },
  beforeDestroy() { document.removeEventListener('click', this.closeAccountOnOutsideClick); }
}
</script>

<style scoped>
/* ── NAV ─────────────────────────────────────────────── */
.tl-nav {
  background: #fff;
  box-shadow: 0 1px 8px rgba(0,0,0,0.08);
  position: sticky;
  top: 0;
  z-index: 500;
}
.tl-nav__inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.tl-nav__logo-img { height: 56px; }
.tl-nav__links {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tl-nav__link {
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  padding: 8px 14px;
  border-radius: 8px;
  transition: background 0.15s;
  white-space: nowrap;
}
.tl-nav__link:hover { background: #F0FAFA; color: #00A7AC; }
.tl-nav__link--alert { color: #b78554; }
.tl-nav__btn {
  background: #00A7AC;
  color: #fff !important;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
  transition: background 0.2s;
}
.tl-nav__btn:hover { background: #008C91; }
.tl-nav__btn--account { position: relative; }
.tl-nav__inbox {
  position: absolute;
  top: -6px; right: -6px;
  background: #ef4444;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  width: 18px; height: 18px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.tl-nav__badge {
  background: #00A7AC;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 999px;
  margin-left: 4px;
}

/* Dropdown */
.tl-nav__dropdown-wrap { position: relative; }
.tl-nav__dropdown.is-open { display: flex; }
.tl-nav__dropdown {
  display: none;
  flex-direction: column;
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  padding: 8px 0;
  min-width: 200px;
  z-index: 100;
}
.tl-nav__dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  font-size: 0.9rem;
  color: #1A2B2B;
  text-decoration: none;
  transition: background 0.15s;
}
.tl-nav__dropdown-item:hover { background: #F0FAFA; color: #00A7AC; }
.tl-nav__dropdown-item i { color: #00A7AC; }
.tl-nav__dropdown-item--danger:hover { color: #ef4444; }
.tl-nav__dropdown-item--danger i { color: #ef4444; }

/* Hamburger — a touch of brand colour */
.tl-nav__hamburger {
  display: none;
  background: none;
  border: 1.5px solid #13452E;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 1.2rem;
  cursor: pointer;
  color: #13452E;
}

/* Mobile drawer — brand dark green with white text + gold icons */
.tl-nav__mobile {
  display: none;
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #13452E;
  z-index: 999;
  flex-direction: column;
  padding: 24px;
}
.tl-nav__mobile.show-menu { display: flex; }
.tl-nav__mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
}
.tl-nav__mobile-close {
  background: none; border: none;
  font-size: 1.5rem; cursor: pointer; color: #fff;
}
.tl-nav__mobile-links { display: flex; flex-direction: column; gap: 2px; }
.tl-nav__mobile-link {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 4px;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid rgba(255,255,255,0.12);
}
.tl-nav__mobile-icon {
  color: #F5A623;
  font-size: 1.15rem;
  width: 22px;
  text-align: center;
  flex-shrink: 0;
}
.tl-nav__mobile-link--btn {
  justify-content: center;
  margin-top: 18px;
  background: #F5A623;
  color: #1A1A1A !important;
  padding: 14px 20px;
  border-radius: 8px;
  text-align: center;
  font-weight: 700;
  border-bottom: none;
}

/* Responsive */
@media (max-width: 768px) {
  .tl-nav__links { display: none; }
  .tl-nav__hamburger { display: flex; }
}
</style>
